import React from 'react';
import EventButton from 'components/EventButton';

export default (props) => {  
    return (
        <EventButton variant="contained" color="primary" style={{ minWidth: '300px', fontWeight: 600 }} {...props}>
            {props.children}
        </EventButton>
    );
};